import { render } from "./TabLabelGenerator.vue?vue&type=template&id=1b7f0904&scoped=true"
import script from "./TabLabelGenerator.vue?vue&type=script&lang=js"
export * from "./TabLabelGenerator.vue?vue&type=script&lang=js"

import "./TabLabelGenerator.vue?vue&type=style&index=0&id=1b7f0904&scoped=true&lang=css"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7f0904"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip});
